import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'numberTruncated',
	standalone: false,
})
export class NumberTruncatedPipe implements PipeTransform {
	transform(value: number | null | undefined, prefix = '', suffix = ''): string {
		if (value === null || value === undefined || isNaN(value)) {
			return '--';
		}

		const absValue = Math.abs(value);
		const sign = value < 0 ? '-' : '';
		let result = '';

		if (absValue >= 1000000) {
			// keep 1 decimal place
			result = (Math.trunc((absValue / 1000000) * 10) / 10).toFixed(1) + 'M';
		} else if (absValue >= 1000) {
			// keep 1 decimal place
			result = (Math.trunc((absValue / 1000) * 10) / 10).toFixed(1) + 'k';
		} else {
			// keep 2 decimal place
			result = (Math.trunc(absValue * 100) / 100).toFixed(2);
		}

		return prefix + sign + result + suffix;
	}
}
